module.exports = __webpack_public_path__ + "img/6.a9f297ca.png";